

export function sideIsTheBlock(side, block) {
	return side.id === block.id;
}

export function sideContainsBlock(side, block) {
	for (const blockInTheSide of side.blocks) {
		if (block.id === blockInTheSide.id) {
			return true;
		}
	}
	return false;
}

export function sideIsRelatedToBlock(side, block) {
	return sideIsTheBlock(side, block) || sideContainsBlock(side, block);
}

